import { makeAutoObservable } from "mobx"
import { get,post } from "../utils/request"
import {userSelf} from '../store'

class Comments {
    list=[]
    loading=false
    limit=10
    offset=0
    total=1
    hasMore=true
    postId=''
    activeCommentId='' // 全局只有一个回复框

    constructor() {
        makeAutoObservable(this)
    }

    async getList(query){
        this.loading=true
        return await get('/api/v1/comment/list',query).finally(()=>this.loading=false)
    }

    reset(){
        this.list=[]
        this.loading=false
        this.limit=10
        this.offset=0
        this.total=1
        this.hasMore=true
        this.postId=''
    }

    resolveHasMore(result, nextOffset) {
        if (typeof result?.hasMore === 'boolean') {
            return result.hasMore
        }
        const total = Number(result?.total)
        if (Number.isFinite(total)) {
            return nextOffset < total
        }
        return false
    }

    loadmore=async (query,refresh=false)=>{
        if(this.loading) return;
        this.postId=query.post
        let limit=query.limit||this.limit
        if(refresh){
            this.offset=0
            this.total=1
            this.hasMore=true
            limit=this.list.length<10?this.limit:this.list.length // 如果是刷新，当前列表长度大于10，就一次性请求目前所有；但对于新增一条知乎的刷新，最后一条会挤出去
        }
        if(!refresh && !this.hasMore) return;
        const result=await this.getList({...query,offset:this.offset,limit})
        if(!result) return
        this.list=[...(refresh?[]:this.list),...result.list]
        const nextOffset = this.offset + limit
        this.offset=nextOffset
        const total = Number(result?.total)
        if (Number.isFinite(total)) {
            this.total=total
        }
        this.hasMore = this.resolveHasMore(result, nextOffset)
        return result
    }
}
export {Comments}
export default new Comments()
